<template>
   <div
      color="warning"
      class="top-warning white--text text-center font-weight-black"
    >
      <v-spacer></v-spacer>
      <h2 id="warning-text">Te encuentras en un ambiente de pruebas, no se procesará ninguna operación realizada aquí.</h2>
    </div>
</template>

<script>

export default {
  name: 'WarningEnvironment'
}
</script>
<style scooped>
  .top-warning {
    background-color: #F9982F;
    top:0px;
    height: 40px;
  }
</style>
